import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Header } from "@/components/feed/Header";
import { Hero } from "@/components/feed/Hero";
import { PostGrid } from "@/components/feed/PostGrid";
import { PostViewer } from "@/components/feed/PostViewer";
import { Newsletter } from "@/components/feed/Newsletter";
import { Marquee, Footer } from "@/components/feed/Chrome";
import { fetchFeed, trendingIds } from "@/lib/feed";

export default function Landing() {
  const [feed, setFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const posts = useMemo(() => feed?.posts || [], [feed]);
  const trending = useMemo(() => trendingIds(posts), [posts]);
  const found = posts.findIndex((p) => p.shortcode === params.get("post"));
  const openIndex = found === -1 ? null : found;

  const setOpenIndex = (i) => setParams(i === null ? {} : { post: posts[i].shortcode }, { replace: true });

  useEffect(() => {
    fetchFeed()
      .then(setFeed)
      .catch(() => setFeed({ posts: [], stale: true }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="landing-page" className="grain relative min-h-screen overflow-hidden">
      <div className="glow -top-40 -left-40 h-[520px] w-[520px] bg-[var(--volt)] opacity-[0.07]" />
      <div className="glow top-[40%] -right-60 h-[600px] w-[600px] bg-[var(--ember)] opacity-[0.06]" />
      <Header profile={feed?.profile} />
      <main className="relative z-10">
        <Hero profile={feed?.profile} />
        <Marquee />
        <PostGrid feed={feed} loading={loading} onOpen={setOpenIndex} trending={trending} />
        <Newsletter />
      </main>
      <Footer />
      <PostViewer posts={posts} index={openIndex} onChange={setOpenIndex} trending={trending} />
    </div>
  );
}
